/*****
転送チャンネルへ投稿するクラス
******/

export default class {
  constructor(param) {

    this.param = param

    const mention = param.mention? `${param.mention.replace('\n', '')}さんからの投稿です。\n`: ''
    const messageURL = `投稿URL：${param.messageURL}\n\n`
    const slackText = typeof param.text === 'string'
      ? param.text
          .replace(/(?:\r?\n)?案件名[：:][^\r\n]*/g, '')
          .replace(/(?:\r?\n)*◎求人情報詳細[\s\S]*?(?=\r?\n◎|\r?\n備考：|\r?\n-----------------------------|$)/g, '')
          .replace(/(?:\r?\n)*◎連絡先情報[\s\S]*?(?=\r?\n備考：|\r?\n-----------------------------|$)/g, '')
          .replace(/(?:\r?\n)*◎MEO\r?\n[\s\S]*?(?=\r?\n◎|\r?\n備考：|\r?\n-----------------------------|$)/g, '')
          .replace(/(?:\r?\n)SEO対象URL：[^\r\n]*/g, '')
          .replace(/(?:\r?\n)店舗URL：[^\r\n]*/g, '')
          .replace(/(?:\r?\n)連絡先情報備考（主要窓口）：[\s\S]*?(?=\r?\n商談同席有無：|\r?\n◎|\r?\n備考：|\r?\n-----------------------------|$)/g, '')
          .replace(/(?:\r?\n)連絡先情報備考：[\s\S]*?(?=\r?\n◎|\r?\n備考：|\r?\n-----------------------------|$)/g, '')
          .replace(/(?:\r?\n)備考欄・特記事項：[\s\S]*?(?=\r?\n◎|\r?\n備考：|\r?\n-----------------------------|$)/g, '')
          .replace(/(?:\r?\n)撮影場所：[^\r\n]*/g, '')
          .replace(/(?:\r?\n)備考：[\s\S]*?(?=\r?\n広告費100万ブーストキャンペーン|\r?\n◎|\r?\n-----------------------------|$)/g, '')
      : param.text
    this.text = mention + messageURL + slackText

    this.channelID = param.channelID
  }
  
  post() {
    if(!this.channelID) {
      console.error('転送先のchannel IDがありません')
      return false
    }  

    try {
      fetch(this.param.slackChannel.postURL, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: `token=${encodeURIComponent(this.param.slackChannel.token)}&channel=${encodeURIComponent(this.channelID)}&username=${encodeURIComponent(this.param.postUser)}&text=${encodeURIComponent(this.text)}&icon_url=${this.param.slackChannel.icon_url}`
      })
      .then(function (response) {
        return response.json()
      }).then(function (response) {

        if(response.message == "not current version") {
          alert(`バージョンが違うようです。\n更新します。`);
          location.reload()
          postResult = false
          return false
        } else {
          
          console.log('転送投稿完了', response)

          return response
        }

      })
      .catch((e) => {
        console.error(e.stack, e.message)
      })
    } catch(e) {
      console.error(e)
    }
  }
}